// Shared signup email check (client + server): RFC-lite local@domain.tld, TLD letters only.
export const EMAIL_MAX_LENGTH = 254;
const LOCAL_PART_MAX_LENGTH = 64;
const LOCAL_PART = /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*$/;
const DOMAIN = /^(?:[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?\.)+[a-z]{2,63}$/;

export const normalizeEmail = (value: unknown): string => (typeof value === 'string' ? value.trim().toLowerCase() : '');

export const isValidEmail = (value: unknown): boolean => {
  const email = normalizeEmail(value);
  if (!email || email.length > EMAIL_MAX_LENGTH) return false;
  const at = email.lastIndexOf('@');
  const local = email.slice(0, at);
  const domain = email.slice(at + 1);
  if (at < 1 || local.length > LOCAL_PART_MAX_LENGTH) return false;
  return LOCAL_PART.test(local) && DOMAIN.test(domain);
};
